import { useState } from "react";
import { useParams } from "react-router-dom";
import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";

function Homepage() {
  const params = useParams();

  let dates = "";
  console.log(params.trip);

  switch (params.trip) {
    case "September-26":
      dates = "September 14 - 23, 2026";
      break;

    case "trip":
      dates = "";
      break;
  }

  return (
    <div className={styles.backgroundPictureIreland}>
      <div className={styles.titleBox}>
        {/* <h1>
          Come to what many consider to be the most beautiful country in the
          world,
        </h1> */}
        <p className={styles.title}>Ireland</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            Experience breathtaking landscapes, rich history, and vibrant
            culture on an unforgettable journey. From the stunning cliffs of
            Moher to the iconic Giant’s Causeway, every corner of this emerald
            isle offers something magical. Whether in Dublin, Belfast, or
            Galway, you will savour traditional Irish cuisine and experience the
            warmth of local hospitality.
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
